/**
 * Get Started Today: init VitalPro funnel membership helpers after deferred bundle loads.
 */
document.addEventListener('DOMContentLoaded', function () {
  if (!window.TymewearFunnelMembership) {
    console.warn(
      '[VitalPro] funnel-membership-step1.js did not load — subscription buttons will not work.'
    );
    return;
  }
  window.TymewearFunnelMembership.initPricingSlider('resize.homeGstPricing');
  window.TymewearFunnelMembership.bindPackageButtons('.GetStartedToday .membership-btn', {
    afterAdd: 'redirect',
  });
});
